import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { deleteChosenStore, saveChosenStore } from '../redux/actions/inStore'
import InStoreModal from './InStore/InStoreModal'
import { RootState } from '../redux/reducers/rootReducer'
import {
  GetMapDispatchTypes,
  ParametersStore,
} from '../interfaces/common/redux'

type Tprops = {
  children?: any
} & ReturnType<typeof mapStateToProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const mapStateToProps = (state: RootState) => ({
  stores: state.stores,
  parameters: state.parameters,
})

const mapDispatchToProps = {
  saveChosenStore: saveChosenStore,
  deleteChosenStore: deleteChosenStore,
}

const InStoreManager = ({
  children,
  stores,
  saveChosenStore,
  parameters,
  deleteChosenStore,
}: Tprops) => {
  const router = useRouter()
  const { t } = useTranslation()
  const [showModale, setShowModale] = useState(false)

  const noModalepaths = [
    '/',
    '/faq',
    '/account',
    '/register',
    '/account/informations/',
    '/confirmation',
  ]

  useEffect(() => {
    if (
      router &&
      router?.query &&
      router?.query?.store &&
      parameters?.items?.in_store
    ) {
      const queryStore = router?.query?.store
      const foundShop = parameters.items.stores.find(
        (store) => store?.slug === queryStore
      )
      if (foundShop) {
        localStorage.setItem('selectedStore', JSON.stringify(foundShop))
      } else {
        localStorage.removeItem('selectedStore')
        deleteChosenStore(router.asPath)
      }
    }
    // handle redirection when on cgl page
    if (
      typeof router?.query?.uid !== 'undefined' &&
      typeof stores?.selectedStore?.slug !== 'undefined'
    ) {
      const pagesUidParameter =
        typeof router?.query?.uid === 'string'
          ? router?.query?.uid
          : router?.query?.uid[0]
      if (
        pagesUidParameter &&
        pagesUidParameter.substring(0, 3) === 'cgl' &&
        pagesUidParameter !== `cgl-${stores?.selectedStore?.slug}` &&
        stores?.selectedStore?.slug !== null
      ) {
        router.push(`cgl-${stores?.selectedStore?.slug}`)
      }
    }
    // You can't access the website if you didn't select a store
    if (
      parameters?.items?.in_store &&
      typeof stores?.selectedStore === 'undefined' &&
      localStorage.getItem('selectedStore') === null
    ) {
      // return to HP
      if (router.pathname !== '/') {
        //router.push('/')
      }
    }
    if (
      localStorage.getItem('selectedStore') === null &&
      typeof stores?.selectedStore !== 'undefined'
    ) {
      // Save store in local storage when selected
      localStorage.setItem(
        'selectedStore',
        JSON.stringify(stores?.selectedStore)
      )
      localStorage.setItem('rmsParcelShopId', stores?.selectedStore?.code)
    }
    if (
      localStorage.getItem('selectedStore') !== null &&
      typeof stores?.selectedStore === 'undefined' &&
      parameters?.items?.stores?.length > 0
    ) {
      // When localStorage has value, refill redux store value
      const storedCode = JSON.parse(
        localStorage.getItem('selectedStore')
      ) as ParametersStore
      const foundStore = parameters.items.stores.find(
        (store) => store.code === storedCode.code
      )

      saveChosenStore(foundStore ?? storedCode)
    }
  }, [stores?.selectedStore, parameters?.items?.in_store])

  useEffect(() => {
    if (parameters?.items?.in_store && !stores?.selectedStore) {
      setShowModale(true)
    }
  }, [stores?.selectedStore, parameters?.items?.in_store])

  return (
    <>
      {parameters?.items?.in_store && showModale && <InStoreModal t={t} />}
      {children}
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(InStoreManager)
